<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="ch00_fm01_praise"></a><a id="page_i"></a>Praise for <em>The Player:</em></p>
<p class="noindent2">“One of the most wounding and satirical of all Hollywood exposes: dark and mordant … savage … A portrait of life among the high rollers and deal makers of a major Hollywood studio in the post—Golden Age. Unnerving … A nightmare rendered with icy dispassion.”</p>
<p class="att">—<em>Los Angeles Times</em></p>
<p class="noindent2">“[A] surely crafted novel … that defines the machinery of moviedom in incisive vivid strokes … A winning black comedy.”</p>
<p class="att">—<em>The Philadelphia Inquirer</em></p>
<p class="noindent2">“Bizarre and brilliant … A grand guide through the private offices, board rooms, and restaurants where Hollywood deals—and throats—are cut.”</p>
<p class="att">—<em>Boston Herald</em></p>
<p class="noindent2">“Deliciously amoral. Just like Hollywood; full of asides and in-jokes and wisecracks.”</p>
<p class="att">—<em>The Washington Post Book World</em></p>
<p class="noindent2">“[A] memorably vivid Hollywood novel.”</p>
<p class="att">—<em>Rolling Stone</em></p>
<p class="noindent2">“Reminiscent of <em>The Last Tycoon</em> … suspense keeps you flipping the pages. <em>The Player</em> is thoroughly convincing, both as a portrait of a power broker and as a depiction of the stratagems within the coterie that runs Tinseltown.”</p>
<p class="att">—<em>The Atlanta Journal-Constitution</em></p>
<p class="noindent2">“An unusually classy mystery.”</p>
<p class="att">—<em>The Plain Dealer</em> (Cleveland)</p>
<p class="noindent2">“Reverberates with the ghosts of Cain and Camus.”</p>
<p class="att">—<em>Women’s Wear Daily</em></p>
<p class="noindent2">“Gets inside Hollywood today…. What makes <em>The Player</em> such a standout work is that it examines the mind-set of the film industry and all its posturing behind the cameras…. It reveals a continuum of viciousness that seems indigenous to Hollywood.”</p>
<p class="att">—<em>The San Diego Union</em></p>
<p class="noindent2"><a id="page_ii"></a>“A thoroughly up-to-date fable that maybe Kafka would have written if he’d been employed at MGM. The book has a sinister inevitability about it and it’s probably as detailed an account of the contemporary Hollywood psyche as we’re likely to find in current fiction. Anyone who has some connection with the film industry should get a big, knowing kick from the book and never be able to look at a studio executive in quite the same light again. Michael Tolkin just about convinces us that the devil is alive and well and hanging out at Morton’s.”</p>
<p class="att">—Bret Easton Ellis</p>
<p class="noindent2">“Icy irony and extreme accuracy.”</p>
<p class="att">—<em>The Village Voice</em></p>
<p class="noindent2">“A scathingly funny tale … a corrosive novel of Hollywood hustling.”</p>
<p class="att">—<em>Premiere</em></p>
<p class="noindent"><a id="page_iii"></a><a id="page_iv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_praise.vue?b1b2a14e